/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line unused-imports/no-unused-imports
import { css, jsx } from "@compiled/react";

import CheckCircleIcon from "@atlaskit/icon/core/check-circle";
import WarningIcon from "@atlaskit/icon/core/status-warning";
import { Box, xcss } from "@atlaskit/primitives";
import Spinner from "@atlaskit/spinner";
import { token } from "@atlaskit/tokens";

const warningIconContainerStyles = css({
    marginInlineStart: token("space.050", "4px"),
    marginInlineEnd: `${token("space.negative.050", "-4px")}`
});

const checkIconContainerStyles = xcss({
    marginInlineStart: "space.100"
});

const spinnerContainerStyles = xcss({
    marginInlineStart: "space.100"
});

export interface ValidationStatusIconProps {
    status?: ValidationStatus;
}

export type ValidationStatus = "valid" | "error" | "pending";

export const ValidationStatusIcon = ({ status }: ValidationStatusIconProps) => {
    if (status === "error") {
        return (
            <div css={warningIconContainerStyles}>
                <WarningIcon
                    label="warning"
                    color={token("color.icon.danger")}
                />
            </div>
        );
    }

    if (status === "valid") {
        return (
            <Box xcss={checkIconContainerStyles}>
                <CheckCircleIcon
                    label="check"
                    color={token("color.icon.success")}
                />
            </Box>
        );
    }

    if (status === "pending") {
        return (
            <Box xcss={spinnerContainerStyles}>
                <Spinner size="small" />
            </Box>
        );
    }

    return null;
};
